import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import { isEmpty, forEach, cloneDeep, find, filter } from "lodash";
import MultiCheckboxSelection from "../MultiCheckboxSelection";
import "./style.scss";

const OsaBrandSelection = (props) => {
  const { defaultValue, onChange } = props;
  const [regionData, setRegionsData] = useState([]);
  const osaBrands = JSON.parse(localStorage.getItem("osa_list"));

  useEffect(() => {
    generateRegionsData(osaBrands);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    combineRegionsWithOutsideData(defaultValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);

  const generateRegionsData = (data) => {
    let Brands = [];
    forEach(data, (sItem) => {
      Brands.push({
        id: sItem.brand_id,
        label: sItem.brand_name,
        isChecked: false,
      });
    });
    setRegionsData(Brands);
  };

  const combineRegionsWithOutsideData = (items) => {
    let Brands = [];
    forEach(osaBrands, (sItem) => {
      Brands.push({
        id: sItem.brand_id,
        label: sItem.brand_name,
        isChecked: false,
      });
    });

    let clonedData = cloneDeep(Brands);

    forEach(clonedData, (sItem) => {
      const matched = find(items, { id: sItem.id });
      sItem.isChecked = !isEmpty(matched) ? matched.isChecked : false;
    });

    setRegionsData(clonedData);
  };

  const onSelectRegion = (mItem, isChecked) => {
    let clonedData = cloneDeep(regionData);

    let matched = find(clonedData, { id: mItem.id });
    if (matched) {
      matched.isChecked = isChecked;
    }
    setRegionsData(clonedData);

    const selectedItems = filter(clonedData, { isChecked: true });
    onChange(selectedItems);
  };

  const onSelectAll = (isChecked) => {
    if (isChecked===true) {
      let clonedData = cloneDeep(regionData);
      forEach(clonedData, (sItem) => {
        sItem.isChecked = isChecked;
      });
      setRegionsData(clonedData);
      onChange(clonedData);
    }
    else{
      let clonedData = cloneDeep(null);
      onChange(clonedData);
    }
  };

  return (
    <div className="custom-table-StoresSelection">
      <div className="StoresSelection-wp">
        <MultiCheckboxSelection
          data={regionData}
          onCheckItem={onSelectRegion}
          onCheckAll={onSelectAll}
        />
      </div>
    </div>
  );
};

OsaBrandSelection.defaultProps = {
  selectedItems: [{ id: "", label: "", isChecked: false }],
  onChange: (value) => {},
};

export default OsaBrandSelection;
